import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCents(cents: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(cents / 100);
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat("pt-BR").format(new Date(date));
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

export function getDaysSince(dateStr: string): number {
  const start = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - start.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

export function getTimeSince(dateStr: string): {
  years: number;
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const start = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - start.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  return {
    years,
    months: months % 12,
    days: days % 30,
    hours: hours % 24,
    minutes: minutes % 60,
    seconds: seconds % 60,
  };
}

export function occasionLabel(occasion: string): string {
  const labels: Record<string, string> = {
    ANNIVERSARY: "Aniversário de namoro",
    BIRTHDAY: "Aniversário",
    VALENTINES_DAY: "Dia dos Namorados",
    MARRIAGE: "Casamento",
    PROPOSAL: "Pedido de namoro",
    OTHER: "Outro",
  };
  return labels[occasion] ?? occasion;
}

export function planLabel(plan: string): string {
  // BASIC mapeia o plano de 24h e PREMIUM o "Para Sempre". DELUXE deixou
  // de ser oferecido na UI, mas mantemos um rótulo seguro caso ainda
  // exista algum gift antigo nesse tier — cai no "Para Sempre".
  const labels: Record<string, string> = {
    BASIC: "Surpresa 24h",
    PREMIUM: "Para Sempre",
    DELUXE: "Para Sempre",
  };
  return labels[plan] ?? plan;
}

export function giftStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    DRAFT: "Rascunho",
    PENDING_PAYMENT: "Aguardando pagamento",
    PUBLISHED: "Publicado",
  };
  return labels[status] ?? status;
}
